import type { QrCode } from "@repo/api";
import { QRCodeSchema } from "@repo/validators";
import { toast } from "sonner";

import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  useForm,
} from "~/components/ui/form";
import { Input } from "~/components/ui/input";
import { api } from "~/lib/api";

export default function QRForm({
  qrCode,
  onClose,
}: {
  qrCode?: QrCode;
  onClose: () => void;
}) {
  const { mutate: saveQrCode } = api.qr.saveQrCode.useMutation();
  const utils = api.useUtils();
  const form = useForm({
    schema: QRCodeSchema,
    defaultValues: {
      tag: qrCode?.tag ?? "",
      target: qrCode?.target ?? "",
      reference: qrCode?.reference ?? "",
    },
  });

  const handleSubmit = form.handleSubmit((data) => {
    saveQrCode(data, {
      onSuccess() {
        toast.success("QR code saved successfully");
        void utils.qr.invalidate();
        onClose();
      },
    });
  });

  return (
    <Form {...form}>
      <form onSubmit={handleSubmit} id="qrForm" className="flex flex-col gap-2">
        <FormField
          control={form.control}
          name="tag"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Tag</FormLabel>
              <Input {...field} />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="target"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Target</FormLabel>
              <Input {...field} />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="reference"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Reference</FormLabel>
              <Input {...field} />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
